/**
 * Created by Marcus Zhao on 02/6/2020.
 *  Description:
 * ------ maintenance history ------
 * 2020/4/12 Bowen: edit relationship and employment part
 * 2020/9/11 Bowen: sync the job title
 */
import { Component, OnInit, Input, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { ReplaySubject, Subject, Subscription, of as observableOf } from 'rxjs';
import { TemplateControlValue } from '@tamalelibs/models/template-control-value.model';
import { EntityType } from '@tamalelibs/models/entity-type.model';
import { EntityService } from '@tamalelibs/services/entity.service';
import { ContactService } from '@tamalelibs/services/contact.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { catchError, take, debounceTime, filter } from 'rxjs/operators';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { ChangeContactTemplateValueSet, ADD_JOB_TITLE, REMOVE_JOB_TITLE } from '@tamalelibs/redux/contact.actions';
import { Entity } from '@tamalelibs/models/entity.model';
import { validRelationshipTypeSelector } from '../../../../redux/reducers/valid-relationship-type.reducer';
import * as _lodash from 'lodash';
import { ControlId, CompanyAction, ContactRelationshipType, RelationshipAction } from '../../contact-dialog.model';
import { ValidRelationshipType } from '@tamalelibs/models/valid-relationship-type.model';
import { ContactTemplateService } from '../../contact-template.service';
import { EntityDialogOpenOptions, EntityDialogType, EntityBack } from '../../../entity-dialog/entity-dialog.model';
import { OpenDynamicComponentService } from '../../../../pages/home/home-open-dynamic-component';
import { AlertWindowService } from '../../../../widgets/alert-window/alert-window.service';
import { HomeViewModel } from '../../../../pages/home/home-view.model';
import { contactNewAddedJobTitleSelector } from '@tamalelibs/redux/contact.reducer';
import { StoreQuerierService } from './../../../../services/store-querier.service';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'ct-dropdown',
    templateUrl: './ct-dropdown.component.html',
    styleUrls: ['./ct-dropdown.component.scss'],
    providers: [HomeViewModel],
    standalone: false
})
export class CtDropdownComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() config: any;
    @Input() valueChangeSubject: ReplaySubject<TemplateControlValue>;
    @ViewChild('dropDownEl', { static: false }) entityEl;

    isNotFly = true;
    readOnly = false; // flag to disable auto complete
    hasPermissionToView = true;
    selectedDictionary: any = {}; // selected items, using dictionary for quickly removing duplicates
    inputValue = ''; // input box text value
    suggestionItems: Array<any> = []; // suggestion items based on search, sub set of dataItems
    defaultItems: Array<any> = []; // defaultItems items based on search, sub set of dataItems
    selectedItem: any; // selected items, sub set of dataItems
    placeholder = '';
    hintContent = '';
    readonlyTip = '';
    showCompanyError = false;
    showEndYearError = false;
    private _searchText = '';
    private _searchValue;
    private _filterHandler$: Subject<string> = new Subject();
    private _destroySubscriptions: Array<Subscription> = [];
    private _validRelationshipTypes: Array<ValidRelationshipType>;
    private _defaultContactAllRelationshipTypes;
    private _defaultContactRelationshipTypes;
    // this var is to save the original company value which has changed
    private _originalCompany = null;
    // this var is to save the original job title value which has changed
    private _originalJobTitle = null;
    // when create the valid company on fly, the current employment need to move to former employment
    // when create the invalid company on fly, the current employment cannot move to former employment
    private _isCreateValidEntity = true;

    constructor(
        private _contactTemplateService: ContactTemplateService,
        private _entityService: EntityService,
        private _contactService: ContactService,
        private _store: Store<AppState>,
        private _openDynamicComponentService: OpenDynamicComponentService,
        private _alertWindow: AlertWindowService,
        private _homeViewModel: HomeViewModel,
        private _storeQuerier: StoreQuerierService,
    ) { }

    ngOnInit() {
        this._destroySubscriptions.push(
            this._store.pipe(
                select(validRelationshipTypeSelector),
                filter(res => res && res.length > 0)
            ).subscribe(res => {
                this._validRelationshipTypes = res;
                this._getRelationshipTypeSuggestionItems();
                this._initRelationshipAndFormerEmploymentStaticValue(); // only for edit
            }),

            this._store.pipe(
                select(contactNewAddedJobTitleSelector),
                filter(res => res && res.length > 0),
            ).subscribe(res => this._handleNewAddedJobTitle(res)),

            this._contactTemplateService.validInputSubject$.subscribe(() => {
                const ctrl = this.config.controlID.indexOf('Former_Employment_EndYear') > -1;
                if (this.config.hasOwnProperty('isRequired') && this.config.isRequired && !this.selectedItem) {
                    if (ctrl) {
                        this.showEndYearError = true;
                        this.hintContent = 'This is required.';
                    }
                } else {
                    this.hintContent = null;
                }
            }),

            this._openDynamicComponentService.feedbackSubject$.subscribe((feedback: EntityBack) => {
                if (feedback.controlId === this.config.controlID) {
                    const indexNumber = parseInt(feedback.currentId, 0);
                    let indexString = '';
                    if (indexNumber > 1) {
                        indexString = (indexNumber - 1).toString();
                    }
                    if (this.config.prefixId === indexString) {
                        this._entityService.getEntityListByIdsQuick([feedback.entityId])
                            .subscribe(res => {
                                this._setFlyValue(res, feedback);
                            });
                        this._changeValueSet();
                    }
                }
            }),

            this._filterHandler$.pipe(
                debounceTime(250),
            ).subscribe(filterStr => {
                if (filterStr && filterStr.length > 0) {
                    this._searching(filterStr);
                } else {
                    this._searching('');
                }
            }),
        );

        if (this.config.staticDefaultValue || this.config.staticDefaultValue === '') {
            // edit contact
            this._initEditValue();
        } else {
            // create contact
            this._initCreateValue();
        }
        // common function
        this._getEmploymentSuggestionYear();
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    handleFilter(value) {
        this._searchValue = value;
        this._filterHandler$.next(value);
    }

    onOpen(event: any) {
        const inputValue = this.entityEl.wrapper.nativeElement.querySelector('input', '.k-multiselect-wrap .k-floatwrap').value;
        // this.suggestionItems = null;
        if (!inputValue && this.config.componentType !== 'med-input') {
            event.preventDefault();
        } else if (this.config.componentType === 'med-input') {
            this.entityEl.toggle(false);
        }
    }

    medOnFocus(event: any) {
        this._searching('');
    }

    clickContactFly() {
        this._searchValue = this.hintContent;
        this._isCreateValidEntity = false;
        this.createEntity();
    }

    valueChange(tappedItem) {
        if (tappedItem) {
            this.hintContent = '';
            this.showCompanyError = false;
            this._contactTemplateService.changeValueStatus = true;
            if (this.config.controlID.indexOf(ControlId.AddRelationshipType) !== -1) {
                const _currentSelectedRelationshipType = {
                    controlId: this.config.controlID,
                    relationshipTypeId: tappedItem.id,
                    relationshipTypeName: tappedItem.name,
                    relationshipType: tappedItem.type,
                    groupId: this.config.groupId
                };
                this._contactTemplateService.actionSubject$.next({
                    type: RelationshipAction.ChangeRelationshipType,
                    payload: _currentSelectedRelationshipType
                });
            } else if (this.config.controlID === 'Company') {
                this._contactTemplateService.actionSubject$.next({
                    type: CompanyAction.ChangeCompany,
                    payload: {
                        originalCompany: this._originalCompany,
                        targetCompany: tappedItem
                    }
                });
                this._originalCompany = {
                    id: this.selectedItem.id,
                    name: this.selectedItem.name,
                };
            }
        }
        // below function is to adjust if we need to dispatch the new added job title to store
        // 1. need to be the relationship part or former employment part
        // 2. need contain the fake id
        if (tappedItem && tappedItem.id && tappedItem.id.toString().indexOf('fakeId') > -1
            && ((this._originalJobTitle && this._originalJobTitle.id && this._originalJobTitle.id !== tappedItem.id) || !this._originalJobTitle)) {
            this._store.dispatch({
                type: ADD_JOB_TITLE,
                payload: {
                    name: tappedItem.name,
                    id: tappedItem.id,
                }
            });
        }
        if (this._originalJobTitle && this._originalJobTitle.id && (!tappedItem || this._originalJobTitle.id !== tappedItem.id)
            && this._originalJobTitle.id.toString().indexOf('fakeId') !== -1) {
            this._store.dispatch({
                type: REMOVE_JOB_TITLE,
                payload: {
                    name: this._originalJobTitle.name,
                    id: this._originalJobTitle.id,
                }
            });
        }
        this._originalJobTitle = this.selectedItem;
        // up function is to adjust if need to dispatch the new added job title to store
        this._changeValueSet();

    }

    clearValue() {
        // simulate user press esc this will toggle the dropdown and remove keyword on filter
        const event = new UIEvent('kendodropdown_keydown');
        event['keyCode'] = 27;
        this.entityEl.keydown(event);
        this.inputValue = '';
        this.selectedItem = null;
        this._searching('');
        this._changeValueSet();
    }

    createEntity() {
        this._showAddEntityDialog();
    }

    createJobTitle() {
        if (this.config.controlID.indexOf('Former_Employment_JobTitle') !== -1) {
            const invalidRelationshipTypeId = 'fakeId' + new Date().getTime();
            const flyRelationship = {
                id: invalidRelationshipTypeId,
                name: this._searchValue
            };
            this.selectedItem = flyRelationship;
            this._originalJobTitle = flyRelationship;

            this._store.dispatch({
                type: ADD_JOB_TITLE,
                payload: flyRelationship
            });
            this.entityEl.clearFilter();
            this.entityEl.toggle(false);
            this._changeValueSet();
        }
    }

    private _changeValueSet() {
        let value = null;
        if (this.selectedItem && this.selectedItem.id && this.selectedItem.name) {
            value = new ContactTemplateControlValue(this.selectedItem.id, this.selectedItem.name, this.config);
        } else {
            value = new ContactTemplateControlValue('', '', this.config);
        }
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }

    private _handleNewAddedJobTitle(newAddedJobTitle) {
        // because the new added controlId has added the hashtime value, need to use indexOf.
        if (this.config.controlID.indexOf(ControlId.AddRelationshipType) !== -1) {
            // need to get all the contact relationship type
            this._filterContactRelationship(this._validRelationshipTypes, newAddedJobTitle);
        } else if (this.config.controlID.indexOf(ControlId.Former_Employment_JobTitle) !== -1) {
            // need to get the contact all relationship type
            this._filterContactAllRelationship(this._validRelationshipTypes, newAddedJobTitle);
        }
    }

    private _initEditValue() {
        if (this.config.readOnly) {
            this.readOnly = this.config.readOnly;
        }
        if (this.config.controlID === 'Company') {
            // to get suggestion items
            this._searching('');
            this._originalCompany = {
                id: this.config.staticDefaultValue,
                name: this.config.companyName,
            };
        }
        // edit contact
        if (this.config.staticDefaultValue) {
            if (this.config.controlID.indexOf(ControlId.Current_Employment_StartYear) !== -1 ||
                this.config.controlID.indexOf(ControlId.Former_Employment_StartYear) !== -1 ||
                this.config.controlID.indexOf(ControlId.Former_Employment_EndYear) !== -1) {
                this.selectedItem = {
                    id: this.config.staticDefaultValue,
                    name: this.config.staticDefaultValue,
                    isPublic: true
                };
            } else if ((this.config.controlID === 'Company' || this.config.controlID.indexOf(ControlId.Former_Employment_Company) !== -1)) {
                if (this.config.companyName === '******' && this.config.staticDefaultValue !== '') {
                    this.selectedItem = {
                        id: this.config.staticDefaultValue,
                        name: this.config.companyName,
                        isPublic: false
                    };
                    this.readonlyTip = 'Company field contains a private entity that you have no permission to view';
                    this.readOnly = true;
                    this.hasPermissionToView = false;
                } else if (this.config.staticDefaultValue !== '' && this.config.companyName !== '******') {
                    this._getEntityDetailWithoutAdhoc(this.config.staticDefaultValue);
                }
            }
        }

        if (this.config.controlID === 'Company' && this.config.staticDefaultValue === '' && this.config.companyName) {
            this.hintContent = this.config.companyName;
            this.showCompanyError = true;
            const subscription = this._alertWindow.info('Invalid Data',
                ['Please correct the data for below field', this.config.controlID]).subscribe((result: boolean) => {
                    subscription.unsubscribe();
                });
        }
        // need to change store, because if we need to save, need to first have job title control, or we cannot save
        // so, we need to dispatch the init result to store
        this._changeValueSet();
    }

    private _initCreateValue() {
        if (this.config.controlID === 'Company' || this.config.controlID.indexOf(ControlId.Former_Employment_Company) !== -1) {
            // to get suggestion items
            this._searching('');
        }
    }

    // this function is for edit contact
    private _initRelationshipAndFormerEmploymentStaticValue() {
        if (this.config.staticDefaultValue) {
            // below part is for new added control after open the dialog, such as change the company function
            // this need to get from store
            // because if we add one control, the init has finished, and the new added control will not get the store value
            let tempValidRelationshipArray = []; // we cannot change the original array, so need to apply a new one
            if (this._storeQuerier.queryBySelector(contactNewAddedJobTitleSelector).length > 0) {
                const convertNewAddedJobTitleArray = []; // need to convert the data model from the store model to the validrelationship model
                this._storeQuerier.queryBySelector(contactNewAddedJobTitleSelector).forEach(ele => {
                    convertNewAddedJobTitleArray.push({
                        relationshipType: {
                            id: ele.id,
                            name: ele.name
                        }
                    });
                });
                tempValidRelationshipArray = this._validRelationshipTypes.concat(convertNewAddedJobTitleArray);
            } else {
                tempValidRelationshipArray = this._validRelationshipTypes;
            }
            // new added control after open the dialog function is over

            // when edit contact, need to get the selected item
            if (this.config.controlID.indexOf(ControlId.Former_Employment_JobTitle) !== -1) {
                tempValidRelationshipArray.forEach(element => {
                    if (element.relationshipType.id === this.config.staticDefaultValue) {
                        this.selectedItem = {
                            id: element.relationshipType.id,
                            name: element.relationshipType.name,
                            isPublic: true
                        };
                    }
                });
            }
            if (this.config.controlID.indexOf(ControlId.AddRelationshipType) !== -1) {
                tempValidRelationshipArray.forEach(element => {
                    if (element.relationshipType.id === this.config.staticDefaultValue.relationshipTypeId) {
                        this.selectedItem = {
                            id: element.relationshipType.id,
                            name: element.relationshipType.name,
                            isPublic: true
                        };
                        this.readOnly = !this.config.staticDefaultValue.isNodeEditable;
                    }
                });
            }
            this._changeValueSet();
        }
    }

    // this function is for create and edit
    // get the valid relationship: contact all - contact all
    private _filterContactAllRelationship(relationshipTypes, newAddedJobTitle?: Array<any>) {
        this.suggestionItems = [];
        relationshipTypes.forEach(element => {
            if (element.childEntityType.id === EntityType.CONTACT.id &&
                element.parentEntityType.id === EntityType.CONTACT.id) {
                this.suggestionItems.push({
                    id: element.relationshipType.id,
                    name: element.relationshipType.name,
                    isPublic: true
                });
            }
        });
        // this function is for new added job title when create a new job title in basic information
        if (newAddedJobTitle && newAddedJobTitle.length > 0) {
            newAddedJobTitle.forEach(item => {
                if (item.count > 0) {
                    this.suggestionItems.push({
                        id: item.id,
                        name: item.name,
                        isPublic: true
                    });
                }
            });
        }
        this.suggestionItems = _lodash.uniqWith(
            this.suggestionItems, _lodash.isEqual);
        if (this.suggestionItems.length !== 0) {
            this.suggestionItems = _lodash.sortBy(this.suggestionItems, item => item.name);
        }
        this._defaultContactAllRelationshipTypes = this.suggestionItems;
    }

    // this function is for create and edit
    private _filterContactRelationship(relationshipTypes, newAddedJobTitle?: Array<any>) {
        this.suggestionItems = [];
        relationshipTypes.forEach(element => {
            if ((element.childEntityType.id === EntityType.CONTACT.id &&
                element.parentEntityType.id === EntityType.CONTACT.id)) {
                this.suggestionItems.push({
                    id: element.relationshipType.id,
                    name: element.relationshipType.name,
                    isPublic: true,
                    type: ContactRelationshipType.ContactAll
                });
            }

            if (element.childEntityType.id === EntityType.CONTACTSFORVALIDRELTYPE.id &&
                element.parentEntityType.id === EntityType.CONTACTSFORVALIDRELTYPE.id) {
                this.suggestionItems.push({
                    id: element.relationshipType.id,
                    name: element.relationshipType.name,
                    isPublic: true,
                    type: ContactRelationshipType.Contact
                });
            }
        });

        // this function is for new added job title when create a new job title in basic information
        if (newAddedJobTitle && newAddedJobTitle.length > 0) {
            newAddedJobTitle.forEach(item => {
                if (item.count > 0) {
                    this.suggestionItems.push({
                        id: item.id,
                        name: item.name,
                        isPublic: true,
                        type: ContactRelationshipType.ContactAll
                    });
                }
            });
        }

        this.suggestionItems = _lodash.uniqWith(
            this.suggestionItems, _lodash.isEqual);
        if (this.suggestionItems.length !== 0) {
            this.suggestionItems = _lodash.sortBy(this.suggestionItems, item => item.name);
        }
        this._defaultContactRelationshipTypes = this.suggestionItems;
    }

    // this function is for create and edit
    private _getEntityDetailWithoutAdhoc(id) {
        this._entityService.getEntityDetailWithoutAdhoc(id)
            .pipe(take(1))
            .subscribe(response => {
                const entity = Entity.parse(response);
                this.selectedItem = entity;
                this._changeValueSet();
            });
    }

    // this function is for create and edit
    private _getRelationshipTypeSuggestionItems() {
        // because the new added controlId has added the hashtime value, need to use indexOf.
        if (this.config.controlID.indexOf(ControlId.AddRelationshipType) !== -1) {
            // need to get all the contact relationship type
            this._filterContactRelationship(this._validRelationshipTypes);
        } else if (this.config.controlID.indexOf(ControlId.Former_Employment_JobTitle) !== -1) {
            // need to get the contact all relationship type
            this._filterContactAllRelationship(this._validRelationshipTypes);
        }
    }

    // this function is for create and edit
    private _getEmploymentSuggestionYear() {
        if (this.config.controlID.indexOf(ControlId.Current_Employment_StartYear) !== -1 ||
            this.config.controlID.indexOf(ControlId.Former_Employment_StartYear) !== -1 ||
            this.config.controlID.indexOf(ControlId.Former_Employment_EndYear) !== -1) {
            this.suggestionItems = [];
            // here is for employment start year filter
            const startYear = new Date().getFullYear();
            for (let i = startYear; i >= 1970; i--) {
                this.suggestionItems.push({
                    id: i,
                    name: i,
                    isPublic: true
                });
            }
        }
    }

    private _searching(text) {
        if (this.config.controlID === 'Company' || this.config.controlID.indexOf(ControlId.Former_Employment_Company) !== -1) {
            if (this.entityEl && this.entityEl.loading) {
                this.entityEl.loading = true;
            }
            this._searchText = text;
            this._contactService.getContactListByText(this._searchText).pipe(
                take(1),
                catchError((e) => {
                    return observableOf();
                }),
            ).subscribe(
                res => {
                    this._searchingDone(res, text);
                    if (this.entityEl && this.entityEl.loading) {
                        this.entityEl.loading = false;
                    }
                }
            );
        } else if (this.config.controlID.indexOf(ControlId.Current_Employment_StartYear) !== -1 ||
            this.config.controlID.indexOf(ControlId.Former_Employment_StartYear) !== -1 ||
            this.config.controlID.indexOf(ControlId.Former_Employment_EndYear) !== -1) {
            this.suggestionItems = [];
            const startYear = new Date().getFullYear();
            for (let i = startYear; i >= 1970; i--) {
                if (i.toString().indexOf(text) !== -1) {
                    this.suggestionItems.push({
                        id: i,
                        name: i,
                        isPublic: true
                    });
                }
            }
        } else if (this.config.controlID.indexOf(ControlId.AddRelationshipType) !== -1) {
            // implement the filter function for former employment job title and add relationship type part
            this.suggestionItems = this._defaultContactRelationshipTypes.filter((item) =>
                item.name.toLowerCase().indexOf(text.toLowerCase()) !== -1);
        } else if (this.config.controlID.indexOf(ControlId.Former_Employment_JobTitle) !== -1) {
            if (text) {
                this.suggestionItems = this._defaultContactAllRelationshipTypes.filter((item) =>
                    item.name.toLowerCase().indexOf(text.toLowerCase()) !== -1);
            } else {
                this.suggestionItems = this._defaultContactAllRelationshipTypes;
            }
        }
    }

    private _searchingDone(entityList, text) {
        this.suggestionItems = this._entityService.mapEntityBriefList(entityList);
        if (text === '') {
            this.defaultItems = this.suggestionItems;
        }
    }

    private _showAddEntityDialog() {
        let index;
        this._homeViewModel.increment();
        this._homeViewModel.getFlyIndex().pipe(take(1)).subscribe(res => index = res);
        const _entityDialogOpenOptions = new EntityDialogOpenOptions();
        _entityDialogOpenOptions.openType = EntityDialogType.NewEntity;
        _entityDialogOpenOptions.instanceId = index.toString();
        _entityDialogOpenOptions.searchValue = this._searchValue;
        _entityDialogOpenOptions.controlId = this.config.controlID;
        _entityDialogOpenOptions.isCreateValidEntity = this._isCreateValidEntity;
        this._openDynamicComponentService.openDialog$.next(_entityDialogOpenOptions);
    }

    private _setFlyValue(entityList, feedback: EntityBack) {
        if (entityList) {
            const item = this._entityService.mapEntityBriefList(entityList)[0];
            if (item) {
                this._originalCompany = this.selectedItem;
                this.selectedItem = item;
                this.suggestionItems = this.defaultItems;
                this.suggestionItems.unshift(this.selectedItem);
                this._changeValueSet();
                this.hintContent = '';
                this.showCompanyError = false;
                if (feedback.isCreateValidEntity) {
                    this._contactTemplateService.actionSubject$.next({
                        type: CompanyAction.CreateValidCompany,
                        payload: {
                            originalCompany: this._originalCompany,
                            targetCompany: this.selectedItem,
                        }
                    });
                } else {
                    if (this.config.controlID === 'Company') {
                        this._contactTemplateService.actionSubject$.next({
                            type: CompanyAction.CreateInvalidCompany,
                            payload: {
                                originalCompany: this._originalCompany,
                                targetCompany: this.selectedItem,
                            }
                        });
                    }
                }
            }
        }
        this._isCreateValidEntity = true;
    }
}
